import { Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Store } from '@ngrx/store';
import { SubSink } from 'subsink';

import {
  ImpersonationActions,
  ImpersonationSelectors,
} from '@app/easylot-admin/modules/impersonation/store/impersonation.slice';
import { UserDetails } from '@authentication/interfaces/user';
import { UserService } from '@authentication/services/user.service';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
})
export class UserMenuComponent implements OnDestroy {
  user?: UserDetails;
  monogram?: string;
  roles: Array<string> = [];
  subs = new SubSink();

  impersonated$ = this.store.select(
    ImpersonationSelectors.selectImpersonatedMerchantId
  );

  constructor(
    private userService: UserService,
    private dialog: MatDialog,
    private store: Store
  ) {
    this.subs.sink = this.userService
      .getUser()
      .subscribe((user: UserDetails) => {
        this.roles = user.roles;
        this.user = user;
        this.monogram = this.user
          ? `${this.user.familyName[0]} ${this.user.givenName[0]}`
          : '';
      });
  }

  removeImpersonation() {
    this.store.dispatch(ImpersonationActions.removeImpersonation.trigger({}));
    this.userService.resetStores();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
